namespace Areas.Favorite {
    "use strict";

    export function goToFavorite(e: any) {
        const grid = Areas.getGrid("FavoriteGrid");
        const row = grid.getSelectedRowsData();

        if (row.length == 1) {
            location.href = row[0].urlAddress;
        }
    }

    export function viewLink(cellElement: any, cellInfo: any) {
        buildCellContent(cellElement,
            () => { return cellInfo.data.urlAddress; },
            "<a href= '{placeholder}' target=\"_blank\">View</a>");
    }

}